export type Theme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'theme';

const isTheme = (value: unknown): value is Theme => value === 'light' || value === 'dark';

export const readSavedTheme = (): Theme | null => {
    try {
        const saved = localStorage.getItem(THEME_STORAGE_KEY);
        return isTheme(saved) ? saved : null;
    } catch {
        return null;
    }
};

export const saveTheme = (theme: Theme): void => {
    try {
        localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
        // Storage refused (blocked site data or full): the theme still applies, it is just not remembered.
    }
};
